
export default function getTilesConfiguration() {
  return [
  ];
}
